export function valuesCodeArray(optionsObject: Record<any, any>) {
  const options = Object.entries(optionsObject).map(([k, v]) => {
    return { label: v, value: v, code: k };
  });
  return options;
}
